<template>
  <div v-if="userReviews.length" class="mb-6">
    <SectionTitle v-model="show">
      {{ totalReviews.toLocaleString('en-US') }} traveler reviews
    </SectionTitle>

    <div v-if="show" class="flex flex-wrap gap-10">
      <div v-for="(review, idx) in userReviews" :key="idx">
        <div class="mb-3 flex items-center gap-2">
          <div>{{ review.score }}</div>
          <div class="flex border border-lime p-1">
            <StarRating :stars="getStars(review)" />
          </div>
        </div>
        <div class="mb-2 text-xl font-medium text-gray-dark">
          {{ review.name }}
        </div>
        <a :href="review.url" target="_blank" rel="noopener noreferrer" class="text-body underline hover:text-black">Read {{ review.num_reviews }} reviews</a>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from '~/components/venue/SectionTitle'
import StarRating from '~/components/shared/StarRating'

export default {
  components: { StarRating, SectionTitle },

  props: {
    userReviews: { type: Array, required: true },
  },

  data: () => ({
    show: true,
  }),

  computed: {
    totalReviews () {
      return this.userReviews.reduce((acc, r) => acc + r.num_reviews, 0)
    },
  },

  methods: {
    getStars (review) {
      const stars = review.score / review.max_score * 5
      const arr = []
      for (let i = 0; i < 5; i++) {
        const diff = stars - i
        arr[i] = diff > 0.7 ? 'full' : (diff > 0.29 && diff <= 0.7 ? 'empty' : 'half')
      }
      return arr
    },
  },
}
</script>
